<template>
  <v-layout row justify-center>
    <v-flex xs12>
          <div class="container-form px-3 py-3">
            <v-tabs
              slider-color="blue"
              grow
            >
              <v-tab
                key="family"
                ripple
              >{{ $t('admissions.council_form.tab_1') }}
              </v-tab>
              <v-tab
                key="prospect"
                ripple
              >{{ $t('admissions.council_form.tab_2') }}
              </v-tab>
              <v-tab
                key="guardians"
                ripple
              >{{ $t('admissions.council_form.tab_3') }}
              </v-tab>
              <v-tab v-if="family_info.expatriado || family_info.multicultural"
                key="non_local"
                ripple
              >{{ $t('admissions.council_form.tab_4') }}
              </v-tab>
              <v-tab
                key="columbus"
                ripple
              >{{ $t('admissions.council_form.tab_5') }}
              </v-tab>
              <v-tab
                key="situation"
                ripple
              >{{ $t('admissions.council_form.tab_6') }}
              </v-tab>
              <v-tab
                key="interviewer"
                ripple
              >{{ $t('admissions.council_form.tab_7') }}
              </v-tab>
              <v-tabs-items class="mt-3">
                <v-tab-item
                  key="family"
                >
                  <v-card flat class="container-form-inner mb-3">
                    <v-card-text>
                      <v-layout row wrap mt-3>
                        <v-flex xs12 lg12 px-1>
                          <v-textarea
                            :form="form"
                            :error-messages="errors.collect('family_general')"
                            v-model="form.family_general"
                            :label="$t('admissions.council_form.family_general')"
                            name="family_general"
                            v-validate="'required'"
                          ></v-textarea>
                        </v-flex>
                        <v-flex xs12 lg12 px-1>
                          <v-textarea
                            :form="form"
                            :error-messages="errors.collect('family_relationship')"
                            v-model="form.family_relationship"
                            :label="$t('admissions.council_form.family_relationship')"
                            name="family_relationship"
                          ></v-textarea>
                        </v-flex>
                        <v-flex xs12 lg12 px-1>
                          <v-textarea
                            :form="form"
                            :error-messages="errors.collect('family_important_values')"
                            v-model="form.family_important_values"
                            :label="$t('admissions.council_form.family_important_values')"
                            name="family_important_values"
                          ></v-textarea>
                        </v-flex>
                        <v-flex xs12 lg12 px-1>
                          <v-textarea
                            :form="form"
                            :error-messages="errors.collect('family_activities')"
                            v-model="form.family_activities"
                            :label="$t('admissions.council_form.family_activities')"
                            name="family_activities"
                          ></v-textarea>
                        </v-flex>
                        <v-flex xs12 lg12 px-1>
                          <v-textarea
                            :form="form"
                            :error-messages="errors.collect('family_rules')"
                            v-model="form.family_rules"
                            :label="$t('admissions.council_form.family_rules')"
                            name="family_rules"
                          ></v-textarea>
                        </v-flex>
                        <v-flex xs12 lg12 px-1>
                          <v-textarea
                            :form="form"
                            :error-messages="errors.collect('family_child_relationship')"
                            v-model="form.family_child_relationship"
                            :label="$t('admissions.council_form.family_child_relationship')"
                            name="family_child_relationship"
                          ></v-textarea>
                        </v-flex>
                        <v-flex xs12 lg12 px-1>
                          <v-textarea
                            :form="form"
                            :error-messages="errors.collect('family_description')"
                            v-model="form.family_description"
                            :label="$t('admissions.council_form.family_description')"
                            name="family_description"
                          ></v-textarea>
                        </v-flex>
                        <v-flex xs12 lg12 px-1>
                          <v-textarea
                            :form="form"
                            :error-messages="errors.collect('family_challenges')"
                            v-model="form.family_challenges"
                            :label="$t('admissions.council_form.family_challenges')"
                            name="family_challenges"
                          ></v-textarea>
                        </v-flex>
                        <v-flex xs12 lg12 px-1>
                          <v-textarea
                            :form="form"
                            :error-messages="errors.collect('family_child_perception')"
                            v-model="form.family_child_perception"
                            :label="$t('admissions.council_form.family_child_perception')"
                            name="family_child_perception"
                          ></v-textarea>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item
                  key="prospect"
                >
                  <v-card flat class="container-form-inner mb-3">
                    <v-card-text>
                      <v-layout row wrap mt-3>
                        <v-flex xs12 lg12 px-1>
                          <v-textarea
                            :form="form"
                            :error-messages="errors.collect('prospect_description')"
                            v-model="form.prospect_description"
                            :label="$t('admissions.council_form.prospect_description')"
                            name="prospect_description"
                          ></v-textarea>
                        </v-flex>
                        <v-flex xs12 lg12 px-1>
                          <v-textarea
                            :form="form"
                            :error-messages="errors.collect('prospect_routine')"
                            v-model="form.prospect_routine"
                            :label="$t('admissions.council_form.prospect_routine')"
                            name="prospect_routine"
                          ></v-textarea>
                        </v-flex>
                        <v-flex xs12 lg12 px-1>
                          <v-textarea
                            :form="form"
                            :error-messages="errors.collect('prospect_pregnancy')"
                            v-model="form.prospect_pregnancy"
                            :label="$t('admissions.council_form.prospect_pregnancy')"
                            name="prospect_pregnancy"
                          ></v-textarea>
                        </v-flex>
                        <v-flex xs12 lg12 px-1>
                          <v-textarea
                            :form="form"
                            :error-messages="errors.collect('prospect_health')"
                            v-model="form.prospect_health"
                            :label="$t('admissions.council_form.prospect_health')"
                            name="prospect_health"
                          ></v-textarea>
                        </v-flex>
                        <v-flex xs12 lg12 px-1>
                          <v-textarea
                            :form="form"
                            :error-messages="errors.collect('prospect_adaptation')"
                            v-model="form.prospect_adaptation"
                            :label="$t('admissions.council_form.prospect_adaptation')"
                            name="prospect_adaptation"
                          ></v-textarea>
                        </v-flex>
                        <v-flex xs12 lg12 px-1>
                          <v-textarea
                            :form="form"
                            :error-messages="errors.collect('prospect_dicipline')"
                            v-model="form.prospect_dicipline"
                            :label="$t('admissions.council_form.prospect_dicipline')"
                            name="prospect_dicipline"
                          ></v-textarea>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item
                  key="guardians"
                >
                  <v-card flat class="container-form-inner mb-3">
                    <v-card-text>
                      <v-layout row wrap mt-3>
                        <v-flex xs12 lg12 px-1>
                          <h3>{{ $t('admissions.council_form.background') }}</h3>
                        </v-flex>
                        <v-flex xs12 lg6 px-1>
                          <v-textarea
                            :form="form"
                            :error-messages="errors.collect('guardian1_background')"
                            v-model="form.guardian1_background"
                            :label="$t('admissions.council_form.guardian_1')"
                            name="guardian1_background"
                          ></v-textarea>
                        </v-flex>
                        <v-flex xs12 lg6 px-1>
                          <v-textarea
                            :form="form"
                            :error-messages="errors.collect('guardian2_background')"
                            v-model="form.guardian2_background"
                            :label="$t('admissions.council_form.guardian_2')"
                            name="guardian2_background"
                          ></v-textarea>
                        </v-flex>
                        <v-flex xs12 lg12 px-1>
                          <h3>{{ $t('admissions.council_form.household') }}</h3>
                        </v-flex>
                        <v-flex xs12 lg6 px-1>
                          <v-textarea
                            :form="form"
                            :error-messages="errors.collect('guardian1_household')"
                            v-model="form.guardian1_household"
                            :label="$t('admissions.council_form.guardian_1')"
                            name="guardian1_household"
                          ></v-textarea>
                        </v-flex>
                        <v-flex xs12 lg6 px-1>
                          <v-textarea
                            :form="form"
                            :error-messages="errors.collect('guardian2_household')"
                            v-model="form.guardian2_household"
                            :label="$t('admissions.council_form.guardian_2')"
                            name="guardian2_household"
                          ></v-textarea>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item v-if="family_info.expatriado || family_info.multicultural"
                  key="non_local"
                >
                  <v-card flat class="container-form-inner mb-3">
                    <v-card-text>
                      <v-layout row wrap mt-3>
                        <v-flex xs12 lg12 px-1>
                          <v-text-field
                            :form="form"
                            :error-messages="errors.collect('non_local_how_long')"
                            v-model="form.non_local_how_long"
                            :label="$t('admissions.council_form.non_local_how_long')"
                            name="non_local_how_long"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 lg12 px-1>
                          <v-textarea
                            :form="form"
                            :error-messages="errors.collect('non_local_medellin')"
                            v-model="form.non_local_medellin"
                            :label="$t('admissions.council_form.non_local_medellin')"
                            name="non_local_medellin"
                          ></v-textarea>
                        </v-flex>
                        <v-flex xs12 lg12 px-1>
                          <v-text-field
                            :form="form"
                            :error-messages="errors.collect('non_local_guardian')"
                            v-model="form.non_local_guardian"
                            :label="$t('admissions.council_form.non_local_guardian')"
                            name="non_local_guardian"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item
                  key="columbus"
                >
                  <v-card flat class="container-form-inner mb-3">
                    <v-card-text>
                      <v-layout row wrap mt-3>
                        <v-flex xs12 lg12 px-1>
                          <v-textarea
                            :form="form"
                            :error-messages="errors.collect('columbus_knowledge')"
                            v-model="form.columbus_knowledge"
                            :label="$t('admissions.council_form.columbus_knowledge')"
                            name="columbus_knowledge"
                          ></v-textarea>
                        </v-flex>
                        <v-flex xs12 lg12 px-1>
                          <v-textarea
                            :form="form"
                            :error-messages="errors.collect('columbus_participation')"
                            v-model="form.columbus_participation"
                            :label="$t('admissions.council_form.columbus_participation')"
                            name="columbus_participation"
                          ></v-textarea>
                        </v-flex>
                        <v-flex xs12 lg12 px-1>
                          <v-textarea
                            :form="form"
                            :error-messages="errors.collect('columbus_relatives')"
                            v-model="form.columbus_relatives"
                            :label="$t('admissions.council_form.columbus_relatives')"
                            name="columbus_relatives"
                          ></v-textarea>
                        </v-flex>
                        <v-flex xs12 lg12 px-1>
                          <v-textarea
                            :form="form"
                            :error-messages="errors.collect('columbus_friends')"
                            v-model="form.columbus_friends"
                            :label="$t('admissions.council_form.columbus_friends')"
                            name="columbus_friends"
                          ></v-textarea>
                        </v-flex>
                        <v-flex xs12 lg12 px-1>
                          <v-textarea
                            :form="form"
                            :error-messages="errors.collect('columbus_family_future')"
                            v-model="form.columbus_family_future"
                            :label="$t('admissions.council_form.columbus_family_future')"
                            name="columbus_family_future"
                          ></v-textarea>
                        </v-flex>
                        <v-flex xs12 lg12 px-1>
                          <v-textarea
                            :form="form"
                            :error-messages="errors.collect('columbus_questions')"
                            v-model="form.columbus_questions"
                            :label="$t('admissions.council_form.columbus_questions')"
                            name="columbus_questions"
                          ></v-textarea>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item
                  key="situation"
                >
                  <v-card flat class="container-form-inner mb-3">
                    <v-card-text>
                      <v-layout row wrap mt-3 v-if="situation">
                        <v-flex xs12 lg12 px-1>
                          <h3>{{ situation.title }}</h3>
                          <p class="mb-0">{{ situation.description }}</p>
                          <v-textarea
                            :form="form"
                            :error-messages="errors.collect('situation_answer')"
                            v-model="form.situation_answer"
                            label=""
                            name="situation_answer"
                          ></v-textarea>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item
                  key="interviewer"
                >
                  <v-card flat class="container-form-inner mb-3">
                    <v-card-text>
                      <v-layout row wrap mt-3>
                        <v-flex xs12 lg12 px-1>
                          <v-textarea
                            :form="form"
                            :error-messages="errors.collect('interviewer_impressions')"
                            v-model="form.interviewer_impressions"
                            :label="$t('admissions.council_form.interviewer_impressions')"
                            name="interviewer_impressions"
                          ></v-textarea>
                        </v-flex>
                        <v-flex xs12 lg12 px-1>
                          <v-select
                            :form="form"
                            :label="$t('admissions.council_form.interviewer_more_info')"
                            :items="options"
                            :error-messages="errors.collect('interviewer_more_info')"
                            name="interviewer_more_info"
                            v-model="form.interviewer_more_info"
                          ></v-select>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-tabs>
            <v-card>
              <v-layout row justify-center align-center px-2>
                <v-checkbox
                  :form="form"
                  :error-messages="errors.collect('accept_policy')"
                  color="success"
                  name="accept_policy"
                  v-model="form.accept_policy"
                  v-validate="'required'"
                >
                  <div slot='label'>{{ $t('admissions.council_form.habeas') }} <strong><a :href="settings.habeas_data" target="_blank">{{ $t('admissions.council_form.habeas_link') }}</a></strong></div>
                </v-checkbox>
                <form @submit.prevent="formValidation" @keydown="form.onKeydown($event)" id="admissions-form">
                  <v-btn
                    form="admissions-form"
                    type="submit"
                    color="primary"
                  >Guardar</v-btn>
                </form>
                </v-layout>
            </v-card>
          </div>
    </v-flex>
  </v-layout>
</template>

<script>
import Form from 'vform'
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: 'admissions_council',
  metaInfo () {
    return { title: 'Formulario de Consejería' }
  },
  props: {
    family: {
      type: Object,
      required: true
    },
    settings: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      appUrl: window.config.appUrl,
      dialog: false,
      dialogVerifyEmail: false,
      form: new Form({
        id: null,
        family_id: this.$props.family.family_id,
        setting_id: this.$props.family.setting_id,
        accept_policy: 1,
        family_general: '',
        guardian1_first_marriage: 1,
        guardian2_first_marriage: 1,
        family_relationship: '',
        family_important_values: '',
        family_activities: '',
        family_rules: '',
        family_child_relationship: '',
        family_description: '',
        family_challenges: '',
        family_child_perception: '',
        prospect_description: '',
        prospect_routine: '',
        prospect_pregnancy: '',
        prospect_health: '',
        prospect_adaptation: '',
        prospect_dicipline: '',
        guardian1_background: '',
        guardian2_background: '',
        guardian1_household: '',
        guardian2_household: '',
        interviewer_impressions: '',
        interviewer_more_info: '',
        columbus_knowledge: '',
        columbus_participation: '',
        columbus_relatives: '',
        columbus_friends: '',
        columbus_family_future: '',
        columbus_questions: '',
        non_local_how_long: '',
        non_local_medellin : '',
        non_local_guardian: ''
      }),
      options: [
        {value: 1, text: this.$t('admissions.form.yesno_options.yes')},
        {value: 0, text: this.$t('admissions.form.yesno_options.no')}
      ],
      family_info : this.$props.family,
      situation: null
    }
  },

  created () {
    this.form.locale = this.locale;
    this.getForm(this.family_info.family_id, this.family_info.setting_id);
  },

  computed: {
    ...mapGetters({
      locale: 'locale'
    }),
  },

  watch: {
    locale(newValue, oldValue) {
      this.form.locale = newValue
    },
    family(newValue, oldValue) {
      this.form = new Form({
        id: null,
        family_id: this.$props.family.family_id,
        setting_id: this.$props.family.setting_id,
        accept_policy: 1,
        family_general: '',
        guardian1_first_marriage: 1,
        guardian2_first_marriage: 1,
        family_relationship: '',
        family_important_values: '',
        family_activities: '',
        family_rules: '',
        family_child_relationship: '',
        family_description: '',
        family_challenges: '',
        family_child_perception: '',
        prospect_description: '',
        prospect_routine: '',
        prospect_pregnancy: '',
        prospect_health: '',
        prospect_adaptation: '',
        prospect_dicipline: '',
        guardian1_background: '',
        guardian2_background: '',
        guardian1_household: '',
        guardian2_household: '',
        interviewer_impressions: '',
        interviewer_more_info: '',
        columbus_knowledge: '',
        columbus_participation: '',
        columbus_relatives: '',
        columbus_friends: '',
        columbus_family_future: '',
        columbus_questions: '',
        non_local_how_long: '',
        non_local_medellin : '',
        non_local_guardian: '',
        situation_id: null,
        situation_answer: ''
      }),
      this.family_info = newValue
      this.getForm(this.family_info.family_id, this.family_info.setting_id);
    },
  },

  methods: {
    close() {
      this.dialog = false
      this.dialogVerifyEmail = false
    },
    getForm(family_id, setting_id) {
      axios.get(`/api/admissions/council_form/${family_id}/${setting_id}`)
        .then(resp => {
          if (resp.status === 200) {
            this.situation = resp.data.situation
            if (resp.data.form) {
              this.form = new Form(resp.data.form)
            }
            this.form.situation_id = this.situation.id
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    async formValidation () {
      if (await this.formHasErrors()) {
        console.log(JSON.stringify(this.errors))
        return
      }

      this.form.post('/api/admissions/council_form', this.form)
        .then(resp => {
          this.getForm(this.family_info.family_id, this.family_info.setting_id);
          this.$store.dispatch('responseMessage', {
              type: 'success',
              text: 'Formulario guardado con éxito',
              modal: true
          })
        })
        .catch(err => {
          console.log(err.response)
        })
    },
  }
}
</script>

<style scoped>
  .container-form{
    background: #6198c8;
    border-radius: 16px;
    box-shadow: -6px 6px 6px #0000001A;
  }
  .container-form-inner{
    background: #F2F2F2;
    border-radius: 30px;
  }
  .container-form-inner .v-card__title, .v-expansion-panel__header .v-card__title{
    color: #004990;
    justify-content: center;
    background: #FFF;
  }
  .upload-picture {
    border-radius: 50%;
    background: #FFF;
    box-shadow: 0px 3px 6px #00000029;
    text-align: center;
    aspect-ratio: 1 / 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .upload-picture img{
    width: 100%;
    border-radius: 50%;
    height: 100%;
    object-fit: cover;
  }
  .upload-picture .example-btn{
    position: absolute;
    bottom: -25px;
    left: 50%;
    transform: translateX(-50%);
  }
  .example-btn .v-btn {
    font-weight: lighter;
    line-height: 38px;
    width: 38px;
    height: 38px;
    font-size: 30px;
    border-radius: 50%;
    min-width: auto;
    padding: 0;
    cursor: pointer;
  }
  .v-expansion-panel {
    box-shadow: none;
  }
  .theme--light.v-expansion-panel .v-expansion-panel__container {
    background-color: transparent;
  }
  .v-expansion-panel__header .v-card__title{
    border-radius: 20px;
  }
  .bg-transparent {
    background: transparent;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/admissions/manage/council_appointment.vue